import { faCrown } from "@fortawesome/free-solid-svg-icons/faCrown";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { AtiraIcon } from "../../../../components/AtiraIcon";
import { FontSize } from "../../../../components/Text";
import { Rounded } from "../../../../theme/Rounded";
import { Spacing } from "../../../../theme/Spacing";

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${Spacing.xs};
  align-self: flex-start;
  padding: ${Spacing.xs} ${Spacing.s};
  border-radius: ${Rounded.sm};
  background-color: ${({ theme }) => theme.main};
  color: ${({ theme }) => theme.white};
  font-size: ${FontSize.xs};
  font-weight: bold;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

export const DashboardSetupPlanBadge: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Badge>
      <AtiraIcon icon={faCrown} size="xs" />
      {t("dashboard.setup.paid_plans")}
    </Badge>
  );
};
